<template functional>
  <a
    v-if="$options.DisplayValue(props)"
    href="#"
    @click="$options.Selected(props)"
    >{{ $options.DisplayValue(props) }}</a
  >
</template>

<script>
import { formatMonto } from "@/utils";

export default {
  name: "CancelHyperlink",
  Selected(props) {
    props.OpenSelect(props);
  },
  DisplayValue(props) {
    const type = props.getType();
    let col = `${props.column}${type === "Cantidad" ? "" : "Amount"}`;
    let value = Number(props.row[col]);
    if (value === 0) {
      return false;
    }
    if (type !== "Cantidad") {
      value = formatMonto(value);
    }
    return value;
  }
};
</script>
